import { ref } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { usePracticeService } from '@repo/modules/portal';
import { Practice, StoredFolder } from '@repo/modules/portal'; //need to change to entity model

export const usePracticeStore = defineStore('practice', () => {
  // services
  const practiceService = usePracticeService();

  // state
  const currentPractice = ref<Practice>({} as Practice);

  // getters

  // actions
  const fetchCurrent = async () => {
    const result = await practiceService.current();
    currentPractice.value = result;
    return result;
  };

  const fetchLogo = () => {
    return practiceService.logo();
  };

  const fetchFolders = () => {
    return practiceService.folders();
  };

  const deleteFolder = (folderPath: string) => {
    return practiceService.deleteFolder(folderPath);
  };

  const createFolder = (path: string, updateEntities: boolean) => {
    return practiceService.createFolder(path, updateEntities);
  };

  const save = (data: Practice, options?: any) => {
    return practiceService.post([data], options);
  };

  const uploadLogo = (logo: File) => {
    return practiceService.uploadLogo(logo);
  };

  const removeLogo = () => {
    return practiceService.removeLogo();
  };

  const renameFolder = (folder: StoredFolder, newName: string) => {
    return practiceService.renameFolder(folder, newName);
  };

  const updateAuditorFolder = (folderName: string) => {
    return practiceService.updateAuditorFolder(folderName);
  };

  const updateClientUploadDefaultFolder = (path: string) => {
    return practiceService.updateClientUploadDefaultFolder(path);
  };

  const fetchDetail = (practiceId: string) => {
    return practiceService.detail(practiceId);
  };

  const state = {
    currentPractice
  };

  const actions = {
    fetchCurrent,
    fetchLogo,
    save,
    uploadLogo,
    removeLogo,
    fetchFolders,
    renameFolder,
    deleteFolder,
    createFolder,
    updateAuditorFolder,
    updateClientUploadDefaultFolder,
    fetchDetail
  };

  return { ...state, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePracticeStore, import.meta.hot));
}
